var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order-card"
  }, [_c('div', {
    staticClass: "px-4 py-4 flex justify-between items-center gap-6 shadow-border-b mdmax:px-4 mdmax:py-4"
  }, [_vm.isMobile ? _c('span', {
    staticClass: "inline-block cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.expand();
      }
    }
  }, [_c('Chevron', {
    attrs: {
      "direction": "down"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "flex gap-4"
  }, [_vm._v("ID: " + _vm._s(_vm.data.id))]), _c('div', {
    staticClass: "flex gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('order.draftOrderCard.continueOrder'),
      "type": 'secondary',
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.continueOnClick(_vm.data.id);
      }
    }
  })], 1)]), _c('div', {
    staticClass: "flex justify-between items-start shadow-border-b text-neutral-500 mdmax:flex-col mdmax:shadow-none",
    class: {
      hidden: !_vm.visibleContent && _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "w-2/5 border-r p-4 mdmax:w-full mdmax:p-4 mdmax:border-none mdmax:shadow-border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-start gap-6 mdmax:gap-2"
  }, [_c('div', {
    staticClass: "w-2/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.senderName')))]), _c('p', {
    staticClass: "font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden",
    attrs: {
      "title": _vm.data.sender_name
    }
  }, [_vm._v(_vm._s(_vm.data.sender_name))]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(_vm._s(_vm.data.sender_phone))])]), _c('div', {
    staticClass: "w-3/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.senderAddress')))]), _c('p', {
    staticClass: "ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
  }, [_vm._v(_vm._s(_vm.data.sender_address))])])]), _c('div', {
    staticClass: "mt-4 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pickup")]), _c('p', [_vm._v(_vm._s(_vm.data.pickup_detail || '-'))])])]), _c('div', {
    staticClass: "w-2/5 border-r p-4 mdmax:border-none mdmax:p-4 mdmax:w-full mdmax:shadow-border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-start gap-6 mdmax:gap-2"
  }, [_c('div', {
    staticClass: "w-2/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700 whitespace-nowrap"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.receiverName')))]), _c('p', {
    staticClass: "font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden",
    attrs: {
      "title": _vm.data.receiver_name
    }
  }, [_vm._v(_vm._s(_vm.data.receiver_name))]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(_vm._s(_vm.data.receiver_phone))])]), _c('div', {
    staticClass: "w-3/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.receiverAddress')))]), _c('p', {
    staticClass: "ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
  }, [_vm._v(_vm._s(_vm.data.receiver_address))])])]), _c('div', {
    staticClass: "mt-4 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.detailShipping')))]), _c('p', [_vm._v(_vm._s(_vm.data.destination_detail || '-'))])])]), _c('div', {
    staticClass: "w-1/5 p-4 mdmax:w-full mdmax:shadow-border-b"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.weight')))]), _c('p', [_vm._v(_vm._s(_vm.data.goods_weight) + " kg")])]), _c('div', {
    staticClass: "mb-3"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderCard.goodsCategory')))]), _c('p', [_vm._v(_vm._s(_vm.data.goods_category))])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }